const COACH_NUTRITION_TAB_ID = "CoachNutrition";

export const shouldShowNutritionFromSidebarConfig = ({ sidebarConfig } = {}) => {
  if (!Array.isArray(sidebarConfig) || sidebarConfig.length === 0) {
    return false;
  }

  return sidebarConfig.some(
    (item) =>
      item?.id === COACH_NUTRITION_TAB_ID && item?.visible !== false
  );
};

export { COACH_NUTRITION_TAB_ID };
